import {
  type HistoryOptions,
  parseAsNativeArrayOf,
  parseAsString,
  useQueryState,
} from 'nuqs';

export const useArraySearchParams = (
  name: string,
  { limit }: { limit?: number } = {},
): [string[], (newValue: string[], updateType?: HistoryOptions) => void, VoidFunction] => {
  const [arrayValue, setArrayValue] = useQueryState(
    name,
    parseAsNativeArrayOf(parseAsString).withDefault([]),
  );

  const setValue = (value: string[], updateType?: HistoryOptions) => {
    if (limit && value.length > limit) {
      value.shift();
    }

    return setArrayValue(value, { history: updateType });
  };

  const reset = () => {
    return setArrayValue([]);
  };

  return [arrayValue as string[], setValue, reset];
};
